'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitterStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var splitterProgress = (0, _styledComponents.keyframes)(['0%{transform:scaleX(.75) translateX(-125%);}30%{transform:scaleX(.75) translateX(-125%);animation-timing-function:cubic-bezier(.42,0,.6,.8);}90%{transform:scaleX(.75) translateX(125%);}100%{transform:scaleX(.75) translateX(125%);}']);

var style = function style(_ref) {
  var themeFromProvider = _ref.theme;
  var componentTheme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider).reactackle.components.progress;
  return (0, _styledComponents.css)(['height:', ';background-color:', ';'], (0, _reactackleCore.getValueString)(componentTheme.linear.thickness), (0, _color2.default)(componentTheme.linear.mainLine.color).string());
};

var SplitterStyled = exports.SplitterStyled = _styledComponents2.default.div.withConfig({
  displayName: 'SplitterStyled'
})(['content:\'\';position:absolute;top:0;left:0;width:100%;will-change:transform;transform-origin:center center;animation:', ' 2s linear infinite;', ' ', ''], splitterProgress, style, (0, _reactackleCore.transition)('transform, background-color', '800ms'));

SplitterStyled.displayName = 'SplitterStyled';